import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'react-bootstrap/Modal';
import 'bootstrap/dist/css/bootstrap.min.css';

import AutoButton from '../../../AutoButton';
import TextInput from '../../../Form/TextInput';
import closeIcon from '../../../../assets/images/dashboard/close.svg';
import classes from './styles.module.scss';

export default function PromptModal({
  show,
  handleClose,
  onConfirm,
  title,
  placeholder,
  initialValue = '',
  maxLength = 100,
}) {
  const { t } = useTranslation();
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    if (show) {
      setValue(initialValue);
    }
  }, [show, initialValue]);

  const handleConfirm = useCallback(() => {
    if (!value.trim()) return;
    onConfirm(value.trim());
    setValue('');
    handleClose();
  }, [value, onConfirm, handleClose]);

  const handleCancel = useCallback(() => {
    setValue('');
    handleClose();
  }, [handleClose]);

  // Handle keyboard shortcuts
  useEffect(() => {
    if (!show) return undefined;

    const handleKeyDown = (e) => {
      if (e.key === 'Enter' && value.trim()) {
        handleConfirm();
      } else if (e.key === 'Escape') {
        handleCancel();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [show, value, handleConfirm, handleCancel]);

  return (
    <Modal
      show={show}
      onHide={handleCancel}
      centered
      className={classes.PromptModal}
      backdropClassName={classes.backdrop}
      contentClassName={classes.modalContent}
      dialogClassName={classes.dialog}
    >
      <div className={classes.content}>
        <header className={classes.header}>
          <h1 className={classes.title}>{title}</h1>
          <button
            type="button"
            className={classes.closeButton}
            onClick={handleCancel}
          >
            <img src={closeIcon} alt="Close" />
          </button>
        </header>

        <div className={classes.form}>
          <TextInput
            name="prompt-input"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder={placeholder}
            maxLength={maxLength}
            height={45}
            inputRef={(input) => {
              if (input && show) {
                setTimeout(() => input.focus(), 100);
              }
            }}
          />
        </div>

        <div className={classes.buttons}>
          <AutoButton variant="black" onClick={handleCancel} height={45}>
            {t('common.cancel')}
          </AutoButton>
          <AutoButton
            height={45}
            onClick={handleConfirm}
            disabled={!value.trim()}
          >
            {t('common.confirm')}
          </AutoButton>
        </div>
      </div>
    </Modal>
  );
}
